// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kvnRm","text":"styles_text__QkQJv"};